import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LookupModel, TextToSpeechResponse} from '../../api/models';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {NotificationService} from '../../notification/notification.service';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LocalPbxService} from '../local-pbx.service';
import {FormHelpers} from '../../core/utilities/form-helpers';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSimpleSelectComponent } from '../../editors/mat-simple-select/mat-simple-select.component';
import { MatTextareaInputComponent } from '../../editors/mat-textarea-input/mat-textarea-input.component';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

export interface HolidayGreetingsTextToSpeechDialogData {

}

@Component({
    selector: 'app-pbx-holiday-greetings-text-to-speech-dialog',
    template: `
    <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
      <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
        <div fxFlex>Generate Holiday Greeting By Text</div>
        <button mat-icon-button [mat-dialog-close]="false" class="button-40">
          <mat-icon>close</mat-icon>
        </button>
      </h1>
      <mat-dialog-content style="display: flex; align-items: stretch;">
        <div fxFlex class="stretched-container">
          <form [formGroup]="form" fxLayout="column" fxLayoutAlign="space-around stretch" novalidate (ngSubmit)="onSubmit()">
            <app-mat-simple-select formControlName="language" label="Language" [selectItems]="languages"></app-mat-simple-select>
            <app-mat-simple-select formControlName="voice" label="Voice" [selectItems]="voices"></app-mat-simple-select>
            <app-mat-textarea-input formControlName="text" label="Text" [rows]="5"></app-mat-textarea-input>

            <button type="button" mat-raised-button color="primary" [promiseBtn]="buttonPreviewPromise" (click)="onPreviewClick(true, false)">Generate</button>

             <div style="display: inline-block; width: 100%; padding: 5px; background-color: transparent; height: 60px;">
                <audio #audioPreview controls></audio>
              </div>
          </form>
        </div>
      </mat-dialog-content>

      <div mat-dialog-actions style="justify-content: flex-end;">
        <button type="button" mat-stroked-button color="primary" (click)="onSubmit()" [disabled]="submitted">Save</button>
        <button type="button" mat-stroked-button [mat-dialog-close]="false">Close</button>
      </div>
    </div>
  `,
    styles: [
        '.stretched-container {overflow: auto;}'
    ],
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatSimpleSelectComponent, MatTextareaInputComponent, MatButton, Angular2PromiseButtonModule, MatDialogActions]
})
export class HolidayGreetingsTextToSpeechDialogComponent implements OnInit, OnDestroy {

  form: FormGroup;
  languageControl = new FormControl('en-US', [Validators.required]);
  voiceControl = new FormControl('', [Validators.required]);
  textControl = new FormControl('', [Validators.required]);
  languages: LookupModel[] = [
    {id: 'en-US', text: 'English'},
  ];
  voices: LookupModel[] = [];

  buttonPreviewPromise: Promise<void>;

  @ViewChild('audioPreview') audioPreview: ElementRef;
  textToSpeechData: TextToSpeechResponse;
  submitted = false;

  constructor(public dialogRef: MatDialogRef<HolidayGreetingsTextToSpeechDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: HolidayGreetingsTextToSpeechDialogData,
              public pbxService: LocalPbxService,
              private notificationService: NotificationService,
              private fb: FormBuilder,
  ) {

  }

  onSubmit() {
    FormHelpers.forceValidate(this.form);
    if(this.form.valid) {
      this.submitted = true;

      if (!this.textToSpeechData?.base64) {
        this.onPreviewClick(false, true);
      } else {
        this.asyncSubmit().then();
      }
    }
  }

  async asyncSubmit() {
    this.submitted = false;

    if (this.textToSpeechData?.base64) {
      this.dialogRef.close(this.textToSpeechData);
    } else {
      this.notificationService.notifyDanger('No text to speech data available. Please generate it first.');
    }
  }

  prepareFormModel(): any {
    const formModel = this.form.getRawValue();

    const fileData = undefined;

    console.log(fileData);

    return {
      text: formModel.text,
      language: formModel.language,
      voiceName: formModel.voice,
    };
  }

  ngOnInit() {
    this.form = this.fb.group({
        'text': this.textControl,
        'voice': this.voiceControl,
        'language': this.languageControl
      },
    );

    this.asyncOnInit().then();
  }

  async asyncOnInit() {
    this.voices = await this.pbxService.getTextToSpeechVoices();
  }

  ngOnDestroy() {

  }

  onPreviewClick(autoPlay: boolean, autoSubmit: boolean) {
    if (this.form.valid) {
      this.buttonPreviewPromise = this.requestHolidayGreeting(autoPlay, autoSubmit);
    }
  }

  async requestHolidayGreeting(autoPlay: boolean, autoSubmit: boolean) {
    const reqData = this.prepareFormModel();
    this.textToSpeechData = await this.pbxService.getGeneratedHolidayGreeting(reqData);
    //console.log('getGeneratedHolidayGreeting', this.textToSpeechData, this.audioPreview);

    const audio: HTMLAudioElement = this.audioPreview.nativeElement;

    audio.src = `data:${this.textToSpeechData.mimeType};base64,${this.textToSpeechData.base64}`;

    if (autoPlay) {
      await audio.play();
    }

    if (autoSubmit) {
      await this.asyncSubmit();
    }
  }

}
